import React from 'react'
import PropTypes from 'prop-types'
import Icon, { availableIconsName } from '../icon'
import styles from './ContactItem.module.css'

const linkPreffix = {
  address: '',
  telephone: 'tel',
  email: 'mailto',
}

const ContactItem = ({ name, value, isLink = true }) => {
  return (
    <div className={styles.contactItem}>
      <Icon name={name} size="1em" />
      {!isLink ? (
        <span className={styles.simpleText}>{value}</span>
      ) : (
        <a
          href={`${linkPreffix[name]}:${value}`}
          target="_blank"
          rel="noopener"
        >
          {value}
        </a>
      )}
    </div>
  )
}

ContactItem.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLink: PropTypes.bool,
}

export default ContactItem
